module.exports = __webpack_public_path__ + "static/media/contactsPurple.2d6396a1.svg";